module.exports = __webpack_public_path__ + "static/media/design-swipe.3026ff15.png";